import React from 'react'
import classes from 'classnames'

const Sidebar = ({ onMount, isMobile, isAbsolute, children, className, noBody }) => {
  // 'Sidebar_person': isPerson,
  const sidebarClasses = classes('Sidebar', className, {
    'Sidebar_absolute': isAbsolute && !isMobile
  })

  const sidebarStyles = {
    bottom: (isAbsolute && !isMobile) ? 0 : null
  }

  const bodyStyles = {
    height: (!isMobile && window.innerHeight)
  }

  return (
    <div className={sidebarClasses} style={sidebarStyles} ref={onMount}>
      <div className='Sidebar__body' style={bodyStyles}>
        {children}
      </div>
    </div>
  )
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.jsx